import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['text']
  static values = {
    startsAt: String,
    i18nStartingNow: String,
    i18nStartsInDays: String,
    i18nStartsInHours: String,
    i18nStartsInMinutes: String,
  }

  connect() {
    const parsed = Date.parse(this.startsAtValue)
    if (Number.isNaN(parsed)) {
      this.element.remove()
      return
    }
    this.targetTime = parsed
    this.lastText = null
    this.update()
    this.startInterval()
    this.onVisibilityChange = this.onVisibilityChange.bind(this)
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  }

  disconnect() {
    this.stopInterval()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  }

  onVisibilityChange() {
    if (document.hidden) {
      this.stopInterval()
    } else {
      this.update()
      if (this.element.isConnected) this.startInterval()
    }
  }

  startInterval() {
    if (this.interval) return
    this.interval = setInterval(() => this.update(), 15_000)
  }

  stopInterval() {
    if (!this.interval) return
    clearInterval(this.interval)
    this.interval = null
  }

  update() {
    if (!this.hasTextTarget) return
    const diff = Math.max(0, Math.floor((this.targetTime - Date.now()) / 1000))
    if (diff === 0) {
      this.stopInterval()
      this.element.remove()
      return
    }
    const days = Math.floor(diff / 86400)
    const hours = Math.floor((diff % 86400) / 3600)
    const minutes = Math.floor((diff % 3600) / 60)
    let text
    if (diff < 60) {
      text = this.i18nStartingNowValue
    } else if (days > 0) {
      text = this.i18nStartsInDaysValue
        .replace('%{days}', days)
        .replace('%{hours}', hours)
    } else if (hours > 0) {
      text = this.i18nStartsInHoursValue
        .replace('%{hours}', hours)
        .replace('%{minutes}', minutes)
    } else {
      text = this.i18nStartsInMinutesValue.replace('%{minutes}', minutes)
    }
    if (text === this.lastText) return
    this.lastText = text
    this.textTarget.textContent = text
  }
}
